import "regenerator-runtime/runtime";
import $ from "jquery";
// import * as Sentry from "@sentry/browser";
import "./lib/select2-bootstrap";
import "../scss/app.scss";

// window.$ = $;

import "./lib/foundation-explicit-pieces";

import libs from "./lib/dependencies";
window.libs = libs;

// init foundation
$(() => {
    $(document).foundation();
});

// SVG REPLACE
svgReplace();

// Initialise Sentry for client-side error monitoring
// Sentry.init({

// 	// This should come from an .env file for JS
// 	dsn: "https://4b3c47436f585206359bf192e0a8ca52@sentry.breuk.dev/96",
// 	environment: 'development',
// 	integrations: [
// 		Sentry.browserTracingIntegration(),
// 	],
// });

// default slick
if ($("[data-init-slick]").length > 0) {
    $("[data-init-slick]").each(function () {
        let $element = $(this);

        // Skip initialization for hidden overlays that should be initialized later
        if ($element.closest('[data-s-type="visuals-overlay"]').length > 0) {
            return;
        }

        let slickSettings = $element.attr("data-slick");

        if (slickSettings) {
            try {
                let settings = JSON.parse(slickSettings);
                $element.slick(settings);
            } catch (e) {
                console.warn("Invalid slick settings:", slickSettings);
                $element.slick();
            }
        } else {
            $element.slick();
        }
    });
}

import "./lib/content/anime";
import "./lib/content/flickity";
import "./lib/content/flickity-hidden-focus";
import "./lib/content/likes";
// import "./lib/content/gallery-full-screen";
import "./lib/content/gf-clear-field-errors";
import "./lib/content/gf-conditional-required";
import "./lib/content/gf-limit-dates-format";
import "./lib/content/gf-locked-choices";
import "./lib/content/go-to-by-scroll";
import "./lib/content/input-number-plus-minus";
import "./lib/content/js-classes";
import "./lib/content/menu";
import "./lib/content/logo-animation";
import "./lib/content/overlay";
import "./lib/content/overlay-page";
import "./lib/content/overlay-template-preview";
import "./lib/content/select2";
import "./lib/content/slider-card-heights";
import "./lib/content/tracking";
import "./lib/content/datalayer-events";
import "./lib/content/datalayer-checkout";
// After tracking, so its ready handler runs first and `form_submit` precedes the form events.
import "./lib/content/gf-form-funnel";
import "./lib/content/trustpilot";
import "./lib/content/video-hover";
import "./lib/content/user-interaction";
import { goToByScroll, svgReplace } from "./lib/content/helper";

// Add goToByScroll to window object
window.goToByScroll = goToByScroll;
